import { Heading } from '@app/app/_components/Heading/Heading';
import { Select } from '@app/app/_components/Input/Select/Select';
import { ProductDataLeasing } from '@app/domain/model/eshop/transport/ProductDataLeasing';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseTransportInsuranceResult } from '@app/service/eshop/transport/actions/purchaseTransportInsurance';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

interface Props {
    cascoLeasings: ProductDataLeasing[];
    formState: FormState<PurchaseTransportInsuranceResult>;
}

export function LeasingPanel({ cascoLeasings, formState }: Props) {
    const t = useTranslations();

    const leasingError = formState.violations?.leasing;

    const leasingsOptions = useMemo(() => {
        if (!cascoLeasings || cascoLeasings.length === 0) {
            return [];
        }
        return [
            { label: t('eshop.general.none'), value: '' },
            ...cascoLeasings.map(cascoLeasing => ({
                label: cascoLeasing.name,
                value: cascoLeasing.code,
            })),
        ];
    }, [cascoLeasings, t]);

    const initialLeasing = formState.data?.formData.leasing || '';

    return (
        <div className="flex flex-col gap-4 px-6">
            <Heading level="h3">{t('eshop.transport.leasings')}</Heading>
            {leasingsOptions.length > 0 && (
                <Select
                    options={leasingsOptions}
                    name="leasing"
                    placeholder={t('eshop.general.select')}
                    defaultValue={initialLeasing}
                    error={leasingError}
                />
            )}
        </div>
    );
}
